/* src/app/dashboard/streaks/user-streak/user-streak.component.scss */
:host {
  --flame-hot: #FFCC00;
  --flame-mid: #FF6B00;
  --flame-normal: var(--primary-color);
}
.streak-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: var(--app-border-radius, 16px);
  background-color: color-mix(in srgb, var(--primary-color) 5%, #f4f6f7);
}
.streak-card--loading {
  align-items: center;
  justify-content: center;
  min-height: 120px;
}
.streak-header {
  display: flex;
  align-items: center;
  gap: 8px;
}
.streak-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--primary-color);
}
.streak-info {
  color: color-mix(in srgb, var(--primary-color) 45%, transparent);
  font-size: 1rem;
}
.streak-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
}
.current-box {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 92px;
  height: 92px;
  border-radius: 20px;
  color: #ffffff;
  background-image:
    linear-gradient(
      to bottom right,
      var(--primary-color),
      color-mix(in srgb, var(--primary-color) 78%, transparent));
  transform-origin: center;
  animation: streak-pop 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}
.current-box::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 70%;
  pointer-events: none;
  background-image:
    linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.22) 50%,
      rgba(255, 255, 255, 0) 100%);
  transform: translateX(-130%);
  animation: streak-shimmer 2.8s ease-in-out 0.45s infinite;
}
@keyframes streak-pop {
  0% {
    opacity: 0;
    transform: scale(0.7);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes streak-shimmer {
  0% {
    transform: translateX(-130%);
  }
  60%, 100% {
    transform: translateX(210%);
  }
}
.current-count {
  font-size: 2.8rem;
  font-weight: 700;
  line-height: 1;
}
.current-unit {
  margin-top: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  opacity: 0.85;
}
.msg-box {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.streak-message {
  font-size: 1.25rem;
  line-height: 1.3;
  color: color-mix(in srgb, var(--primary-color) 60%, #6b7785);
  text-align: left;
}
.flame-char {
  display: inline;
  color: var(--flame-normal);
  animation: flame-text 0.36s ease-out forwards;
}
@keyframes flame-text {
  0% {
    color: var(--flame-hot);
  }
  50% {
    color: var(--flame-mid);
  }
  100% {
    color: var(--flame-normal);
  }
}
.best-message {
  font-size: 1.15rem;
  color: var(--primary-color);
  font-weight: 700;
  text-align: left;
}
.streak-inactive {
  color: var(--primary-color);
  background-image: none;
  background-color: color-mix(in srgb, var(--primary-color) 12%, transparent);
  animation: streak-pop 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}
.streak-inactive::after {
  background-image:
    linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.3) 50%,
      rgba(255, 255, 255, 0) 100%);
}
@media (prefers-reduced-motion: reduce) {
  .current-box,
  .streak-inactive {
    animation: none;
  }
  .current-box::after {
    animation: none;
    opacity: 0;
  }
  .flame-char {
    animation: none;
    color: var(--flame-normal);
  }
}
/*# sourceMappingURL=user-streak.component.css.map */
